var _circle, _circle2, _circle3, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCircles2Faq(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 245,
    height: 325,
    viewBox: "0 0 245 325",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 73.4709,
    cy: 85.2959,
    r: 36.6899,
    transform: "rotate(-169.076 73.4709 85.2959)",
    stroke: "black"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    r: 1.89744,
    transform: "matrix(0.981881 0.189499 0.189499 -0.981881 107.467 71.3727)",
    fill: "black"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    r: 1.89744,
    transform: "matrix(0.981881 0.189499 0.189499 -0.981881 76.0996 121.747)",
    fill: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M228.115 34.9967C155.602 21.002 85.4741 68.4402 71.4794 140.953C57.4848 213.465 104.923 283.593 177.435 297.588C249.948 311.583 320.076 264.144 334.071 191.632C348.065 119.119 300.627 48.9914 228.115 34.9967ZM228.304 34.0148C155.249 19.9155 84.5969 67.7084 70.4976 140.763C56.3982 213.818 104.191 284.47 177.246 298.57C250.301 312.669 320.953 264.876 335.053 191.821C349.152 118.767 301.359 48.1142 228.304 34.0148Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircles2Faq);
export default __webpack_public_path__ + "static/media/circles2_faq.732b81f0d419adba13f3bc40e0fb2796.svg";
export { ForwardRef as ReactComponent };